import { player_game_session_activity } from './api/entities';

export const actions = {
  resetPlayerGameSessionActivityState: 'RESET_PLAYER_GAME_SESSION_ACTIVITY_STATE',
  createPlayerGameSessionActivity: 'CREATE_PLAYER_GAME_SESSION_ACTIVITY',
  updatePlayerGameSessionActivity: 'UPDATE_PLAYER_GAME_SESSION_ACTIVITY',
  listPlayerGameSessionActivity: 'LIST_PLAYER_GAME_SESSION_ACTIVITY',
  getPlayerGameSessionActivity: 'GET_PLAYER_GAME_SESSION_ACTIVITY',
};

export function resetPlayerGameSessionActivityState() {
  return { type: actions.resetPlayerGameSessionActivityState };
}

export function createPlayerGameSessionActivity(player_game_session_activityObject) {
  return player_game_session_activity.create(
    actions.createPlayerGameSessionActivity,
    player_game_session_activityObject,
    []
  );
}

export function updatePlayerGameSessionActivity(player_game_session_activityId, player_game_session_activityObject) {
  return player_game_session_activity.update(
    actions.updatePlayerGameSessionActivity,
    player_game_session_activityId,
    player_game_session_activityObject,
    []
  );
}

export function getPlayerGameSessionActivities(query, sort) {
  return player_game_session_activity.list(actions.listPlayerGameSessionActivity, query, sort);
}

export function getPlayerGameSessionActivity(player_game_session_activityId) {
  return player_game_session_activity.get(actions.getPlayerGameSessionActivity, player_game_session_activityId, []);
}

const INITIAL_STATE = {
  player_game_session_activities: [],
  player_game_session_activity: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetPlayerGameSessionActivityState:
      return {
        ...INITIAL_STATE,
      };
    case actions.createPlayerGameSessionActivity:
      return {
        ...state,
        player_game_session_activities: action.body
          ? [...state.player_game_session_activities, action.body]
          : state.player_game_session_activities,
      };
    case actions.listPlayerGameSessionActivity:
      return {
        ...state,
        player_game_session_activities: action.body ? action.body._items : state.player_game_session_activities,
      };
    case actions.getPlayerGameSessionActivity:
      return {
        ...state,
        player_game_session_activity: action.body ? action.body : state.player_game_session_activity,
      };
    case actions.updatePlayerGameSessionActivity:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    default:
      return {
        ...state,
      };
  }
}
